import { Button, Flex, notification } from "antd";
import React from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useEditProductContext } from "../../../contexts/edit-product-context/useEditProductContext";
import { colors, shadows } from "../../../styles/theme";

const ProductEditBar: React.FC = () => {
  const {
    setUnsavedChanges,
    save,
    updateProductMutateAsyncIsLoading,
  } = useEditProductContext();

  const query = useQueryClient();
  const navigate = useNavigate();

  const handleSave = async () => {
    await save();
    // Navigate back after a brief delay so the success notification is visible
    setTimeout(() => navigate("/menu"), 600);
  };

  const handleCancel = () => {
    setUnsavedChanges(false);
    query.invalidateQueries("/product");
    notification.info({
      message: "Zmiany porzucone",
      style: { background: "#e6f4ff" },
      placement: "bottomRight",
    });
    navigate("/menu");
  };

  return (
    <div
      style={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        boxShadow: shadows.subtle,
        padding: "12px",
        zIndex: 100,
        backgroundColor: colors.white,
      }}
    >
      <Flex gap={6} justify="space-between" align="center">
        <Button
          style={{ height: "40px", width: "100%" }}
          onClick={handleCancel}
          disabled={updateProductMutateAsyncIsLoading}
        >
          Anuluj
        </Button>
        <Button
          style={{ height: "40px", width: "100%" }}
          type="primary"
          onClick={handleSave}
          loading={updateProductMutateAsyncIsLoading}
          disabled={updateProductMutateAsyncIsLoading}
        >
          Zapisz
        </Button>
      </Flex>
    </div>
  );
};

export default ProductEditBar;
